export const CLUBSPARK_ORG_ID = '00000001-0000-0000-0000-000000000000';
export const NATIONAL_SECTION_ID = '96a7c92e-92cb-4965-8284-8e5a33761130';
